import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { StatisticSummaryFilterEntity } from '../../domain/entities/StatisticSummaryFilterEntity'

export class StatisticSummaryFilterModel extends StatisticSummaryFilterEntity {
  startDate: string = ''
  endDate: string = ''
  branchId?: number
  serviceId?: number
  regionId?: number
  constructor(dataDto: StatisticSummaryFilterEntity) {
    super()
    mapEntityProperties<StatisticSummaryFilterModel>(this, dataDto, {
      exclude: ['beginDate', 'finalDate', 'branch', 'service', 'region'],
      map: {
        startDate: dataDto.beginDate,
        endDate: dataDto.finalDate,
        branchId: dataDto.branch?.id,
        serviceId: dataDto.service?.id,
        regionId: dataDto.region?.id
      }
    })
  }
}
